import { IconProps } from "@assets";

const PauseButton = ({ ...props }: IconProps): JSX.Element => {
    return (
        <svg
            width={props.size ?? "48"}
            height={props.size ?? "48"}
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="24" cy="24" r="24" fill="#F0F7FA" />
            <rect x="13" y="13" width="8" height="21" rx="2" fill="#3266A8" />
            <rect x="27" y="13" width="8" height="21" rx="2" fill="#3266A8" />
        </svg>
    );
};

export default PauseButton;
